export default __webpack_public_path__ + "static/media/industry_pink.e8595db5.png";